/**
 * @generated SignedSource<<839b55d289df719be40ab3859cb6f187>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ArchiveReportInput = {
  reportId: string;
};
export type useReportArchiveMutation$variables = {
  input: ArchiveReportInput;
};
export type useReportArchiveMutation$data = {
  readonly archiveReport: {
    readonly report: {
      readonly id: string;
      readonly rowId: any;
      readonly company: {
        readonly id: string;
      } | null;
    };
  } | null;
};
export type useReportArchiveMutation = {
  variables: useReportArchiveMutation$variables;
  response: useReportArchiveMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ArchiveReportPayload",
    "kind": "LinkedField",
    "name": "archiveReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Report",
        "kind": "LinkedField",
        "name": "report",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useReportArchiveMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useReportArchiveMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "841b6f4fcc580dcbc3853af87bf8a3a8",
    "id": null,
    "metadata": {},
    "name": "useReportArchiveMutation",
    "operationKind": "mutation",
    "text": "mutation useReportArchiveMutation(\n  $input: ArchiveReportInput!\n) {\n  archiveReport(input: $input) {\n    report {\n      id\n      rowId\n      company {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "46b668352b01979d6deff889aad98714";

export default node;
